import { FirebaseMessageActions } from '@/hooks/common/useFirebaseListener';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

export interface Notification {
  requested: number;
  preparing: number;
  recent: Recent | null;

  [prop: string]: any;
}

interface Recent {
  action: FirebaseMessageActions;
  body: string;
  title: string;
  orderId?: string;
  orderExternalId?: string;
  isPaid?: string;
}

const { persistAtom } = recoilPersist();

export const notificationState = atom({
  key: 'notification',
  default: {
    requested: 0,
    preparing: 0,
    recent: null
  },
  effects_UNSTABLE: [persistAtom]
});
